import React, { useEffect, useRef } from "react";
import ProductList from "../components/ProductList";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiBaseUrl } from "../config";
import { getCartInfo } from "../reducer/userCartSlice";
import {
  getCollectionTotalCount,
  getSellerCollection,
} from "../reducer/fetchCollectionSlice";
import { getDomainInfo } from "../utils/utils";
import { useUser } from "../context/userContext";

const Home = () => {
  const dispatch = useDispatch();
  const customerId = localStorage.getItem("customerId");
  const cartContext = localStorage.getItem("cartContext");
  const hasFetched = useRef(false);
  const { userId } = useParams();
  const { uid } = getDomainInfo(userId);
  const { userData, fetchUserData } = useUser();

  // **Move useSelector to the top level**
  const userid = useSelector((state) => state?.fetchUser?.user?.id);
  const userPhone = useSelector((state) => state.fetchUser?.user?.phone);
  useEffect(() => {
    if (uid) {
      fetchUserData(uid);
    } else {
      console.error("UID is undefined, skipping fetchUserData.");
    }
  }, [uid]);

  // useEffect(() => {
  //   const pixelId = userData?.pixelId;

  //   if (!pixelId) return;

  //   if (!window.fbq) {
  //     (function (f, b, e, v, n, t, s) {
  //       if (f.fbq) return;
  //       n = f.fbq = function () {
  //         n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  //       };
  //       if (!f._fbq) f._fbq = n;
  //       n.push = n;
  //       n.loaded = !0;
  //       n.version = '2.0';
  //       n.queue = [];
  //       t = b.createElement(e);
  //       t.async = !0;
  //       t.src = v;
  //       s = b.getElementsByTagName(e)[0];
  //       s.parentNode.insertBefore(t, s);
  //     })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  //   }

  //   console.log("before using ", pixelId);
  //   window.fbq('init', pixelId);
  //   console.log("after using ", pixelId);
  //   window.fbq('',pixelId)
  //   // Always track page view
  //   window.fbq('track', 'PageView');

  //   if (productData) {
  //     window.fbq('track', 'ViewContent', {
  //       content_name: productData.title,
  //       content_ids: [productData.skuId],
  //       content_type: 'product',
  //       value: productData.price,
  //       currency: 'INR'
  //     });
  //   }

  //   // Example: You can trigger AddToCart & Purchase elsewhere on button clicks / success pages
  // }, [userData, productData]);
  

  const fetchSellerCollectionDetails = async () => {
    try {
      if (!userid) throw new Error("userid is undefined, skipping API call.");

      const response = await fetch(
        `${apiBaseUrl}user/get-seller-collections-details/${userid}`
      );

      const data = await response.json();

      if (data?.sellerCollections) {
        dispatch(getSellerCollection(data.sellerCollections));
        dispatch(getCollectionTotalCount(data.totalCount));
      }
    } catch (error) {
      console.error("Error fetching Seller Collections:", error);
    }
  };

  const fetchUserCartInfo = async (storeId, token) => {
    try {

      if (!userid)
        // throw new Error("userid is undefined, skipping cart API call.");
      console.warn("userid is undefined, skipping cart API call.");

      const response = await fetch(`${apiBaseUrl}cart/fetch-user-cart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ storeid: userid, customerId, cartContext }),
      });

      const data = await response.json();

      if (data?.cart) {
        dispatch(getCartInfo(data.cart));
      }
    } catch (error) {
      console.error("Error fetching User Cart Information:", error);
    }
  };

  const init = async () => {
    if (!userid) {
      console.error("Skipping API calls because userid is undefined.");
      return;
    }
    await fetchSellerCollectionDetails();
    const token = localStorage.getItem("token");
    await fetchUserCartInfo(userid, token);
  };

  useEffect(() => {
    if (userid && !hasFetched.current) {
      init();
      hasFetched.current = true;
    } else if (!userid) {
      console.error("userid is undefined, skipping API calls.");
    }
  }, [userid]);

  return (
    <div className="home-page home-page-layout-2">
      <ProductList />
      <a href={`https://wa.me/${userPhone}`} className="whatsapp-float" target="_blank"><img src="/assets/images/whatsapp.png" alt="Chat on WhatsApp" width="50" /></a>

    </div>
  );
};

export default Home;
